import { render, staticRenderFns } from "./WidgetForm.vue?vue&type=template&id=2ad0d63e&scoped=true"
import script from "./WidgetForm.vue?vue&type=script&lang=js"
export * from "./WidgetForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetForm.vue?vue&type=style&index=0&id=2ad0d63e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad0d63e",
  null
  
)

export default component.exports